import { createSlice } from '@reduxjs/toolkit'

const calculateTotal = (items) =>
  items.reduce((total, item) => total + item.price * item.quantity, 0)

const cartSlice = createSlice({
  name: 'cart',
  initialState: {
    items: [],
    total: 0,
  },
  reducers: {
    addToCart: (state, action) => {
      const existingItem = state.items.find(item => item.id === action.payload.id)
      if (existingItem) {
        existingItem.quantity += 1
      } else {
        state.items.push({ ...action.payload, quantity: 1 })
      }
      state.total = calculateTotal(state.items)
    },
    removeFromCart: (state, action) => {
      state.items = state.items.filter(item => item.id !== action.payload)
      state.total = calculateTotal(state.items)
    },
    updateQuantity: (state, action) => {
      const { id, quantity } = action.payload
      const item = state.items.find(item => item.id === id)
      if (item) {
        if (quantity <= 0) {
          state.items = state.items.filter(item => item.id !== id)
        } else {
          item.quantity = quantity
        }
      }
      state.total = calculateTotal(state.items)
    },
    clearCart: (state) => {
      state.items = []
      state.total = 0
    },
    setCartItems: (state, action) => {
      state.items = action.payload
      state.total = calculateTotal(state.items)
    }
  },
})

export const { addToCart, removeFromCart, updateQuantity, clearCart, setCartItems } = cartSlice.actions
export default cartSlice.reducer

